import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Grid, Button, Stack, Box, 
  Paper, Typography, Badge,  IconButton
} from '@mui/material';

import {
  fetchRequests,
  selectRequestIds, 
  selectRequestById, 
  readRequest,
  deleteRequest} from '../../store/requestSlice'

import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

import ViewProvider from '../../utils/ViewContext'

import {useNavigate, Outlet} from 'react-router-dom' 

import {usePlayContext} from '../../utils/PlayContext';

const PassPage = () => {

  const {
    setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    setTenantLogo
  }=usePlayContext()

  const dispatch = useDispatch();

  const doFetchData= async()=>{

    setStatus('loading')

    try
    {
       let x = dispatch(fetchRequests(0)).unwrap()
        setStatus('idle')

    }
    catch (ex)
    {

        setStatus('error')
        setErrorMessage('Fetch error')
    }
  }
  

  useEffect(()=>{
      setOp('')
      
      
      
      doFetchData()


      return ()=>{
        setOp('')
      
      }
  },[])

  return (
    <Box>
       
       <ViewProvider> 
      <Paper sx={{border:'none', justifyContent: "flex-start", p:1}} elevation={4} >
        
          
          <Outlet/>
          
         
      </Paper>
      </ViewProvider>
      
    </Box  >
  );
};

export default PassPage;
